import { render, staticRenderFns } from "./HdsDropdown.vue?vue&type=template&id=f2d754de&scoped=true&"
import script from "./HdsDropdown.vue?vue&type=script&lang=ts&"
export * from "./HdsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./HdsDropdown.vue?vue&type=style&index=0&id=f2d754de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d754de",
  null
  
)

export default component.exports